export const checkResize = (object) => new Promise((resolves, rejects) => {
	let size = {width: 0, height:0};

	try{
		size.width = object.offsetWidth;
	    size.height = object.offsetHeight;
	    console.log(size);
	    resolves(size);
	}catch(error){
		console.log(object);
		rejects(error);
	}
});

export const loadImage = path => new Promise((resolves, rejects) =>{
    let image = new window.Image();

    try{
      if(path === "./") throw new Error();
      image.src = require("./"+path);	

      resolves(image);
    }catch(error){
      rejects(error);
    }
});

export const updateObject = (object, changes) => {
	let newObject = {...object};
	delete changes.type;
  
	for (let property in changes){
		newObject[property] = changes[property];
	} 

	return newObject;
};

export const storeIt = (key, value) => {
	try {
		const storedValue = window.localStorage.getItem(key)||{};
		const valueToStore = value instanceof Function ? value(JSON.parse(storedValue)) : value;
		window.localStorage.setItem(key, JSON.stringify(valueToStore)); 
		return true;
	}catch(error){
		console.log(error);
		return false;
	}	
};

export const getStoredItem = key => {
	try{
		return JSON.parse(window.localStorage.getItem(key))||undefined;
	}catch(error){
		console.log(error);
	}
}

export const isMobile = () => {
	if(window.screen.width/window.screen.height > 1)return false;
	return true;
};

export const parseTimeToString = time => {
	time = new Date(time);

	let sec = time.getSeconds();
	let min = time.getMinutes();

	if(sec < 10) sec = "0" + sec;
	if(min < 10) min = "0" + min;

	return min+":"+sec;
}